<template>
  <div>
    <PageHead title="人员权限">
      <a-alert
        class="mt10 mr20 mb10"
        message="此表单只做人员权限展示，如需改动请到相应的列表页面进行操作！"
        type="info"
        show-icon
      />
    </PageHead>

    <div class="oa-layout-content">
      <div class="search-flex">
        <div class="query-top-select">
          <div class="query-cont">
            <div class="query-view mr20">
              <div class="query-view-lable">姓名：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入"
                v-model="queryForm.applypeople"
              />
            </div>
            <div class="query-view mr20">
              <div class="query-view-lable">部门：</div>
              <a-tree-select
                allowClear
                v-model="queryForm.organization_id"
                class="w200"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                placeholder="请选择部门"
                tree-default-expand-all
                :replaceFields="{
                  key: 'id',
                  value: 'id',
                  children: 'treeList',
                  title: 'organizationName'
                }"
              >
              </a-tree-select>
            </div>
            <div class="query-view">
              <div class="query-view-lable">电话：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入"
                v-model="queryForm.phone"
              />
            </div>
          </div>
        </div>
        <div class="search-flex-itemm">
          <a-button type="primary" @click="subMit" :loading="loading"
            >查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()"
            >取消</a-button
          >
        </div>
      </div>
      <div class="mb20 search-btns">
        <span class="statistics">检索统计： {{ total }} 条</span>
      </div>
      <a-table
        class="statusDiv"
        :pagination="false"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="(record) => record.id"
        :expandRowByClick="false"
        :expandIconAsCell="false"
        :expandIconColumnIndex="3"
        :expandIcon="(props) => this.customExpandIcon(props)"
      >
        <span slot="index" slot-scope="text, record, index">{{
          index + 1 + (page - 1) * 10
        }}</span>
        <div slot="expandedRowRender" slot-scope="record">
          <a-table
            class="statusDiv"
            :pagination="false"
            :columns="columns1"
            :data-source="record.userrolesRes"
            :loading="loading"
            :row-key="(record, index) => index"
          >
            <div
              slot="work"
              class="flexCont"
              slot-scope="text, record"
              @click="
                $router.push(
                  '/addInstitutionalFramework?id=' +
                    record.organizationId +
                    '&isCreate=2'
                )
              "
            >
              {{ text }}
              <!-- ---{{ record.organizationId }} -->
            </div>
            <div slot="permissionswork" slot-scope="text, record">
              <span class="mr10 mb10 whiteSpace">
                <a-checkbox
                  checked
                  :disabled="getIt('1', record.permissionswork)"
                ></a-checkbox>
                发起人可见
              </span>
              <span class="mr10 mb10 whiteSpace">
                <a-checkbox
                  checked
                  :disabled="getIt('2', record.permissionswork)"
                ></a-checkbox>
                审批人可见
              </span>
              <span class="mr10 mb10 whiteSpace">
                <a-checkbox
                  checked
                  :disabled="getIt('3', record.permissionswork)"
                ></a-checkbox>
                部门可见
              </span>
            </div>
          </a-table>
          <blank height="20"> </blank>
          <a-table
            class="statusDiv"
            :pagination="false"
            :columns="columns2"
            :data-source="record.permissionsMenuRes"
            :loading="loading"
            :row-key="(record) => record.id"
          >
            <!-- @click="$router.push('/role')" 原来要跳转的 -->
            <div
              slot="labelname"
              slot-scope="text, record"
              class="flexCont"
              @click="$router.push(`/userList`)"
            >
              <template v-for="(item, index) in record.menuList">
                <span class="mr10 mb10 whiteSpace" :key="index">
                  <a-checkbox checked :disabled="!item.results"></a-checkbox>
                  {{ item.label }}
                </span>
              </template>
            </div>
          </a-table>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>
<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: { customRender: 'index' },
    // width: 80,
    align: 'left'
  },
  {
    title: '姓名',
    dataIndex: 'fullName',
    key: 'fullName',
    scopedSlots: { customRender: 'fullName' },
    ellipsis: true
  },
  {
    title: '电话',
    dataIndex: 'phoneNumber',
    key: 'phoneNumber',
    ellipsis: true
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'center',
    width: 150
  }
]

import { PermissionsxList } from './api/api'
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      queryForm: {},
      data: [],
      columns,
      columns1: [
        {
          title: '部门',
          dataIndex: 'organizationname',
          key: 'organizationname'
        },
        {
          title: '审批角色',
          dataIndex: 'work',
          key: 'work',
          scopedSlots: { customRender: 'work' }
        },
        {
          title: '数据权限',
          dataIndex: 'permissionswork',
          scopedSlots: { customRender: 'permissionswork' },
          key: 'permissionswork'
        }
      ],
      columns2: [
        {
          title: '应用',
          dataIndex: 'label',
          key: 'label',
          width: 250
        },
        {
          title: '页面权限',
          dataIndex: 'labelname',
          scopedSlots: { customRender: 'labelname' },
          key: 'labelname'
        }
      ],
      total: 0,
      page: 1,
      size: 10,
      loading: false
    }
  },
  computed: {
    ...mapState({
      treeData: (state) => state.app.treeData // 组织机构树
    })
  },
  created() {
    //获取组织机构
    this.getorganizeListFn()
    this.load()
  },
  methods: {
    getIt(item, list) {
      let arr = list.split(',')
      let index = arr.indexOf(item)
      if (index == -1) {
        return true
      } else {
        return false
      }
    },

    ...mapActions(['getorganizeListFn']),
    // 拉取列表

    load() {
      this.loading = true
      let params = this.queryForm
      params.page = this.page
      params.size = this.size
      PermissionsxList(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.data = res.data.data
          this.total = res.data.count
        }
      })
    },
    showDeleteConfirm(id) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          delBriefing({ id }).then((res) => {
            if (res.data.code == 0) {
              this.$message.success('删除成功')
              this.page = 1
              this.load()
            }
          })
        }
      })
    },
    goDetial(id, type) {
      if (type) {
        const { href } = this.$router.resolve({
          path: '/BriefReportDetial',
          query: {
            id: id,
            isEdit: '1'
          }
        })
        window.open(href, '_self')
      } else {
        if (id) {
          const { href } = this.$router.resolve({
            path: '/BriefReportDetial',
            query: {
              id: id
            }
          })
          window.open(href, '_self')
        } else {
          const { href } = this.$router.resolve({
            path: '/BriefReportDetial'
          })
          window.open(href, '_self')
        }
      }
    },
    pageChange(pageber) {
      this.page = pageber
      this.load()
    },
    cancel() {
      //取消
      this.queryForm = {}
    },
    subMit() {
      this.page = 1
      this.load()
    },
    customExpandIcon(props) {
      if (props.expanded) {
        return (
          <a
            onClick={(e) => {
              props.onExpand(props.record, e)
            }}
          >
            <a-button type="link" icon="up">
              收起
            </a-button>
          </a>
        )
      } else {
        return (
          <a
            onClick={(e) => {
              props.onExpand(props.record, e)
            }}
          >
            <a-button type="link" icon="down">
              展开
            </a-button>
          </a>
        )
      }
    }
  }
}
</script>
<style scoped>
/deep/ tr.ant-table-expanded-row,
tr.ant-table-expanded-row:hover {
  background: #fff !important;
}
</style>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .query-top-select {
    width: calc(100% - 180px);
    .query-cont {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      // flex-wrap: wrap;
      .query-view {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        .query-view-lable {
          width: 75px;
          height: 22px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          line-height: 22px;
          text-align: right;
          margin-right: 5px;
        }
      }
    }
  }
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
.search-btns {
  position: relative;
  height: 10px;
  .statistics {
    position: absolute;
    right: 50px;
    font-size: 14px;
  }
}

.statusDiv {
  border: rgba(198, 198, 198, 1) solid 1px;
}
.whiteSpace {
  white-space: nowrap;
}
.flexCont {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/system/personnelAccess.vue